import { CharacterSheet } from "../data/characterSchema";

export const exportToMarkdown = (character: CharacterSheet): string => {
  let md = `# Ficha de Personagem - ${character.nomePersonagem || "Sem Nome"}\n\n`;

  // Informações Básicas
  md += `## Informações Básicas\n\n`;
  md += `**Nome do Personagem:** ${character.nomePersonagem}\n\n`;
  md += `**Jogador:** ${character.jogador}\n\n`;
  md += `**Data de Criação:** ${character.dataCriacao}\n\n`;
  md += `**Nível de Experiência:** ${character.nivelExperiencia}\n\n`;
  md += `**Reino Atual:** ${character.reinoAtual}\n\n`;
  md += `---\n\n`;

  // Atributos
  md += `## Atributos\n\n`;
  md += `| Atributo | Nível | Modificador | Custo Total |\n`;
  md += `|----------|-------|-------------|-------------|\n`;
  md += `| **Força (FOR)** | ${character.atributos.FOR.nivel} | ${character.atributos.FOR.modificador || "-"} | ${character.atributos.FOR.custoTotal || "-"} |\n`;
  md += `| **Destreza (DES)** | ${character.atributos.DES.nivel} | ${character.atributos.DES.modificador || "-"} | ${character.atributos.DES.custoTotal || "-"} |\n`;
  md += `| **Constituição (CON)** | ${character.atributos.CON.nivel} | ${character.atributos.CON.modificador || "-"} | ${character.atributos.CON.custoTotal || "-"} |\n`;
  md += `| **Inteligência (INT)** | ${character.atributos.INT.nivel} | ${character.atributos.INT.modificador || "-"} | ${character.atributos.INT.custoTotal || "-"} |\n`;
  md += `| **Sabedoria (SAB)** | ${character.atributos.SAB.nivel} | ${character.atributos.SAB.modificador || "-"} | ${character.atributos.SAB.custoTotal || "-"} |\n`;
  md += `| **Carisma (CAR)** | ${character.atributos.CAR.nivel} | ${character.atributos.CAR.modificador || "-"} | ${character.atributos.CAR.custoTotal || "-"} |\n`;
  md += `| **Poder Espiritual (POD)** | ${character.atributos.POD.nivel} | ${character.atributos.POD.modificador || "-"} | ${character.atributos.POD.custoTotal || "-"} |\n\n`;
  md += `**Total de Pontos Gastos em Atributos:** ${character.totalPontosGastosAtributos}\n\n`;
  md += `---\n\n`;

  // Valores Derivados
  md += `## Valores Derivados\n\n`;
  md += `**Pontos de Vida (PV):**\n`;
  md += `- **PV Máximos:** ${character.valoresDerivados.pvMaximos} (CON × 6)\n`;
  md += `- **PV Atuais:** ${character.valoresDerivados.pvAtuais} / ${character.valoresDerivados.pvMaximos}\n\n`;
  md += `**Pontos de Qi (PQ):**\n`;
  md += `- **PQ Máximos:** ${character.valoresDerivados.pqMaximos} ((POD × 10) + CON)\n`;
  md += `- **PQ Atuais:** ${character.valoresDerivados.pqAtuais} / ${character.valoresDerivados.pqMaximos}\n\n`;
  md += `---\n\n`;

  // Reino de Cultivo
  md += `## Reino de Cultivo\n\n`;
  md += `**Reino Atual:** ${character.reinoCultivo.nivel} (Nome: ${character.reinoCultivo.nome})\n\n`;
  md += `**Multiplicador:** ${character.reinoCultivo.multiplicador}\n\n`;
  md += `**Limite de Atributos:** ${character.reinoCultivo.limiteAtributos}\n\n`;
  md += `**Próximo Reino:** ${character.reinoCultivo.proximoReino}\n\n`;
  md += `**Preparação para Tribulação:** ${character.reinoCultivo.preparacaoTribulacao}\n\n`;
  md += `---\n\n`;

  // Raízes Espirituais
  md += `## Raízes Espirituais\n\n`;
  if (character.raizesEspirituais.length > 0) {
    md += `| Raiz Espiritual | Nível | Elemento | Bônus | Custo |\n`;
    md += `|-----------------|-------|----------|-------|-------|\n`;
    character.raizesEspirituais.forEach(raiz => {
      md += `| ${raiz.nome} | ${raiz.nivel} | ${raiz.elemento} | ${raiz.bonus} | ${raiz.custo} |\n`;
    });
  } else {
    md += `*Nenhuma raiz espiritual registrada.*\n`;
  }
  md += `\n---\n\n`;

  // Técnicas
  md += `## Técnicas Conhecidas\n\n`;
  if (character.tecnicas.length > 0) {
    md += `| Técnica | Categoria | Nível | Custo PQ | Efeito |\n`;
    md += `|---------|-----------|-------|----------|--------|\n`;
    character.tecnicas.forEach(tecnica => {
      md += `| ${tecnica.nome} | ${tecnica.categoria} | ${tecnica.nivel} | ${tecnica.custoPQ} | ${tecnica.efeito} |\n`;
    });
  } else {
    md += `*Nenhuma técnica registrada.*\n`;
  }
  md += `\n---\n\n`;

  // Domínio
  if (character.dominio) {
    md += `## Domínio\n\n`;
    md += `**Conceito do Dao:** ${character.dominio.conceitoDao}\n\n`;
    md += `**Custo de Ativação:** ${character.dominio.custoAtivacao} PQ\n\n`;
    md += `**Custo por Rodada:** ${character.dominio.custoPorRodada} PQ\n\n`;
    md += `**Raio:** ${character.dominio.raio} metros\n\n`;
    md += `**Efeito Especial:** ${character.dominio.efeitoEspecial}\n\n`;
    md += `---\n\n`;
  }

  // Identidades
  md += `## Identidades\n\n`;
  md += `**Slots Disponíveis:** ${character.slotsIdentidades}\n\n`;
  if (character.identidades.length > 0) {
    md += `| Identidade | Sobreposição | Efeitos |\n`;
    md += `|------------|--------------|---------|\n`;
    character.identidades.forEach(identidade => {
      md += `| ${identidade.nome} | ${identidade.sobreposicao} | ${identidade.efeitos} |\n`;
    });
  } else {
    md += `*Nenhuma identidade registrada.*\n`;
  }
  md += `\n---\n\n`;

  // Destino
  if (character.destino) {
    md += `## Destino\n\n`;
    md += `**Nível de Destino:** ${character.destino.nivel}\n\n`;
    md += `**Encontros de Sorte:** ${character.destino.encontrosSorte}\n\n`;
    md += `**Tribulações Súbitas:** ${character.destino.tribulacoesSubitas}\n\n`;
    md += `---\n\n`;
  }

  // Face e Humanidade
  md += `## Face e Humanidade\n\n`;
  md += `**Face Atual:** ${character.faceHumanidade.faceAtual}\n\n`;
  md += `**Humanidade:** ${character.faceHumanidade.humanidade}%\n\n`;
  md += `**Efeitos:** ${character.faceHumanidade.efeitos}\n\n`;
  md += `---\n\n`;

  // Perícias
  md += `## Perícias\n\n`;
  const periciasCombate = character.pericias.filter(p => 
    p.nome.includes("Combate") || p.nome.includes("Desarmado")
  );
  const periciasTecnica = character.pericias.filter(p => 
    ["Alquimia", "Matrizes", "Mecânica"].includes(p.nome)
  );
  const periciasSocial = character.pericias.filter(p => 
    ["Persuasão", "Liderança", "Negociação"].includes(p.nome)
  );
  const periciasOcultismo = character.pericias.filter(p => 
    ["Meditação", "Conhecimento Oculto", "Rituais"].includes(p.nome)
  );

  if (periciasCombate.length > 0) {
    md += `### Combate\n\n`;
    md += `| Perícia | Atributo | Nível | Especializações |\n`;
    md += `|---------|----------|-------|----------------|\n`;
    periciasCombate.forEach(pericia => {
      const especializacoes = pericia.especializacoes.map(e => `${e.nome} (${e.nivel})`).join(", ") || "-";
      md += `| **${pericia.nome}** | ${pericia.atributo} | ${pericia.nivel} | ${especializacoes} |\n`;
    });
    md += `\n`;
  }

  if (periciasTecnica.length > 0) {
    md += `### Técnica\n\n`;
    md += `| Perícia | Atributo | Nível | Especializações |\n`;
    md += `|---------|----------|-------|----------------|\n`;
    periciasTecnica.forEach(pericia => {
      const especializacoes = pericia.especializacoes.map(e => `${e.nome} (${e.nivel})`).join(", ") || "-";
      md += `| **${pericia.nome}** | ${pericia.atributo} | ${pericia.nivel} | ${especializacoes} |\n`;
    });
    md += `\n`;
  }

  if (periciasSocial.length > 0) {
    md += `### Social\n\n`;
    md += `| Perícia | Atributo | Nível | Especializações |\n`;
    md += `|---------|----------|-------|----------------|\n`;
    periciasSocial.forEach(pericia => {
      const especializacoes = pericia.especializacoes.map(e => `${e.nome} (${e.nivel})`).join(", ") || "-";
      md += `| **${pericia.nome}** | ${pericia.atributo} | ${pericia.nivel} | ${especializacoes} |\n`;
    });
    md += `\n`;
  }

  if (periciasOcultismo.length > 0) {
    md += `### Ocultismo\n\n`;
    md += `| Perícia | Atributo | Nível | Especializações |\n`;
    md += `|---------|----------|-------|----------------|\n`;
    periciasOcultismo.forEach(pericia => {
      const especializacoes = pericia.especializacoes.map(e => `${e.nome} (${e.nivel})`).join(", ") || "-";
      md += `| **${pericia.nome}** | ${pericia.atributo} | ${pericia.nivel} | ${especializacoes} |\n`;
    });
    md += `\n`;
  }

  md += `---\n\n`;

  // Vantagens e Desvantagens
  md += `## Vantagens e Desvantagens\n\n`;
  md += `### Vantagens\n\n`;
  if (character.vantagens.length > 0) {
    md += `| Vantagem | Nível | Custo |\n`;
    md += `|----------|-------|-------|\n`;
    character.vantagens.forEach(vantagem => {
      md += `| ${vantagem.nome} | ${vantagem.nivel} | ${vantagem.custo} |\n`;
    });
  } else {
    md += `*Nenhuma vantagem registrada.*\n`;
  }
  md += `\n### Desvantagens\n\n`;
  if (character.desvantagens.length > 0) {
    md += `| Desvantagem | Nível | Ganho |\n`;
    md += `|-------------|-------|-------|\n`;
    character.desvantagens.forEach(desvantagem => {
      md += `| ${desvantagem.nome} | ${desvantagem.nivel} | ${desvantagem.ganho} |\n`;
    });
  } else {
    md += `*Nenhuma desvantagem registrada.*\n`;
  }
  md += `\n---\n\n`;

  // Equipamentos
  md += `## Equipamentos\n\n`;
  if (character.equipamentos.length > 0) {
    md += `| Equipamento | Tipo | Nível | Efeitos |\n`;
    md += `|-------------|------|-------|---------|\n`;
    character.equipamentos.forEach(equipamento => {
      md += `| ${equipamento.nome} | ${equipamento.tipo} | ${equipamento.nivel} | ${equipamento.efeitos} |\n`;
    });
  } else {
    md += `*Nenhum equipamento registrado.*\n`;
  }
  md += `\n---\n\n`;

  // Inventário
  md += `## Inventário\n\n`;
  if (character.inventario.length > 0) {
    md += `| Item | Tipo | Quantidade | Efeitos |\n`;
    md += `|------|------|------------|---------|\n`;
    character.inventario.forEach(item => {
      md += `| ${item.nome} | ${item.tipo} | ${item.quantidade} | ${item.efeitos} |\n`;
    });
  } else {
    md += `*Inventário vazio.*\n`;
  }
  md += `\n---\n\n`;

  // Experiência
  md += `## Experiência e Progressão\n\n`;
  md += `**XP Atual:** ${character.experiencia.xpAtual}\n\n`;
  md += `**XP Total Acumulado:** ${character.experiencia.xpTotalAcumulado}\n\n`;
  md += `**Pontos de Personagem Disponíveis:** ${character.experiencia.pontosDisponiveis} (10 XP = 1 ponto)\n\n`;
  md += `---\n\n`;

  // Notas
  if (character.notas) {
    md += `## Notas e Observações\n\n`;
    md += `${character.notas}\n\n`;
  }

  return md;
};

export const exportToJSON = (character: CharacterSheet): string => {
  return JSON.stringify(character, null, 2);
};

export const downloadFile = (content: string, filename: string, mimeType: string) => {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
